import { Injectable } from '@angular/core';
import {HttpService} from '../auth/http.client.service';
import {Response, URLSearchParams} from '@angular/http';
import {Constants} from './constants';
import {Observable} from '../../../node_modules/rxjs';
import {NotificationType} from '../core/notify';
import {NotificationBarService} from '../core/notify/notification.service';
import {environment} from '../../environments/environment';
import {RulesService} from './rules.service';
import {RuleModel} from './model/RuleModel';

@Injectable()
export class ChannelService {
  private channelUri =  `${environment.serviceBase}/actions`;
  constructor(private http: HttpService,
              private notifier: NotificationBarService,
              private ruleService: RulesService) { }

  getActions() {
    const params = this.setParams({type: Constants.CHANNEL_TYPE.OUTPUT})
    return this.http.get(this.channelUri, params)
      .map(response => response.json().data.items)
      .catch(this.handleError);
  }

  getStatus(id): Promise<any> {
    this.ruleService.resetSavedThings();
    let count = 0;
    let promise = new Promise((resolve, reject) => {
      if (!id || isNaN(id)) {
        resolve(false);
      }
      if (!this.ruleService.getRuleModel()) {
        this.ruleService.getRule(id)
          .subscribe(res => {
            this.ruleService.setRule(res);
            let thingIds = this.getDependentThings(res);
            if (!thingIds.length) {
              resolve(false);
            }
            for (let i = 0, limit = thingIds.length ; i < limit; i++) {
              this.ruleService.getThingDetails(thingIds[i])
                .subscribe(response => {
                  count++;
                  if (limit === count) {
                    resolve(true);
                  }
                  }, error => resolve(false));
            }
          }, err => resolve(false) );
      } else {
        let thingIds = this.getDependentThings(this.ruleService.getRuleModel());
        if (!thingIds.length) {
          resolve(false);
        }
        for (let i = 0, limit = thingIds.length ; i < limit; i++) {
          this.ruleService.getThingDetails(thingIds[i])
            .subscribe(response => { count++; if (limit === count) { resolve(true); } }, error => resolve(false));
        }
      }
    });
    return promise;
  }

  private getDependentThings(rule: RuleModel) {
    if (!rule.predicate.conditions) {
      return [];
    }
    let thingList = [];
    const conditions = rule.predicate.conditions;
    conditions.forEach(item => {
      if (thingList.indexOf(item.attributeParent) < 0) {
        thingList.push(item.attributeParent);
       }
       if (item.constraint.referenceId === 'null') {
          return;
       }
       if (item.constraint.referenceId && thingList.indexOf(item.constraint.referenceId) < 0) {
         thingList.push(item.constraint.referenceId);
       }
    })
    return thingList;
  }
  private setParams = (args) => {
    let params: URLSearchParams = new URLSearchParams();
    for (const key in args) {
      if (args.hasOwnProperty(key)) {
        params.set(key, args[key]);
      }
    }

    return params;
  }
  private handleError =  (error: Response | any) => {
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      errMsg = body.status ? body.status.message : body;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    this.notifier.create({message: errMsg, type: NotificationType.Error});
    return Observable.throw(errMsg);
  }



}



// WEBPACK FOOTER //
// ./src/app/rules/channel.service.ts